import React, { ReactNode } from 'react';
import { eventTypes, useForm } from 'new/elements/Form/useForm';
import { Button } from 'new/elements/Button';
import { CircularProgress } from '@mui/material';
import ContextualSupportContainer from 'js/components/support/ContextualSupportContainer';
import classNames from 'classnames';

import classes from './FormHeaderActions.module.scss';

interface FormHeaderActionsProps {
  LeftView?: ReactNode;
  RightView?: ReactNode;
  containerClassName?: string;
  onCancel?: () => void;
}

export const FormHeaderActions = (props: FormHeaderActionsProps) => {
  const { RightView, containerClassName } = props;
  const {
    activePage,
    steps,
    nextPage,
    sendEvent,
    awaitingValidation,
    continueBlockedExternally,
    confirmButtonTitle = 'Continue',
    cancelButtonTitle = 'Discard Changes',
    setShowLeaveConfirmation,
  } = useForm();

  if (!steps || !steps.length || activePage < steps[0].index) {
    return null;
  }
  const continueDisabled = !!awaitingValidation || !!continueBlockedExternally;
  const onContinue = () => {
    nextPage();
  };

  const onCancel = () => {
    sendEvent(eventTypes.CANCEL);
    if (props.onCancel) {
      props.onCancel();
      return;
    }
    setShowLeaveConfirmation(true);
  };

  return (
    <div className={classNames(classes.container, containerClassName)}>
      <div className={classes.innerContainer}>
        <Button
          data-testid="form-header-back-button"
          disabled={awaitingValidation}
          onClick={onCancel}
          variant="outlined"
          color="basic"
        >
          {cancelButtonTitle}
        </Button>
        <Button
          onClick={onContinue}
          data-testid="form-header-next-button"
          variant="ghost"
          disabled={continueDisabled}
          color="primary"
        >
          {continueDisabled ? <CircularProgress size={20} /> : confirmButtonTitle}
        </Button>

        {RightView}

        <ContextualSupportContainer />
      </div>
    </div>
  );
};

FormHeaderActions.displayName = 'FormHeaderActions';
